import Quill from 'quill'

import { loadEmbedScript, embedScriptSrc } from '../utils'

export class SocialEmbed extends Quill.import('blots/block/embed') {
  static blotName = 'social'
  static tagName = 'div'
  static className = 'social-embed'

  static create(value: string) {
    const domNode = super.create()

    domNode.innerHTML = value
    domNode.dataset.quillEmbedCode = value

    loadEmbedScript(embedScriptSrc(domNode))

    return domNode
  }

  static value(domNode: HTMLElement) {
    return domNode.dataset.quillEmbedCode
  }
}
